
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M506.866 209.681L370.528 316.25l48.973 161.66c.92 3.034 1.109 5.008 1.109 6.396 0 8.625-6.681 15.306-15.305 15.306-3.059 0-6.209-.706-9.183-2.783L256.72 399.442l-139.68 97.387c-5.828 4.063-12.24 3.62-18.359 0-5.568-4.174-7.74-10.08-5.568-17.25l49.53-163.329L6.299 209.68c-5.307-4.148-6.958-9.741-5.01-17.25 2.505-6.957 7.235-10.299 14.751-10.299h170.008l55.651-160.545c2.42-6.987 7.513-10.299 15.021-10.299 7.518 0 12.329 3.312 14.752 10.299l55.645 160.546H497.13c6.677 0 12.797 3.9 14.188 10.299 2.505 7.23 1.032 12.965-4.452 17.25zm-185.774-2.171c-7.854 0-13.086-3.589-15.71-11.177L256.73 55.822l-48.945 140.511c-2.644 7.58-7.858 11.177-15.413 11.177H43.707l118.746 92.768c5.099 3.978 7.593 11.694 5.744 17.825L125.29 460.426l122.074-84.609c5.925-4.106 12.3-4.249 18.432 0l122.083 84.609-42.911-142.323c-1.851-6.13.648-13.848 5.739-17.825L469.46 207.51H321.092z"}})])
          )
        }
      }
    